import elementLocale from 'element-ui/lib/locale/lang/de';
import messages from './messages.json';

const updatedElementLocale = { ...elementLocale };
updatedElementLocale.el.datepicker.year = '';
updatedElementLocale.el.pagination.pagesize = 'Artikel';

const translations = {
  de: {
    ...messages,
    ...elementLocale,
  },
};

export default translations;
